export default function getMonthDays(date, month, index, context) {
  if (!date) {
    return 'N/A'
  }
  var d = new Date().getFullYear()+month+(date < 10 ? '0' + date  : date );
  var day = new Date().getFullYear() + '-' + month + '-' + (date < 10 ? '0' + date  : date );

  if(!context.array_dates[index]){
    var array = [];
    context.array_dates.push(array);
  }

  if(!context.array_dates[index].includes(d)){
    context.array_dates[index].push(d);
  }

  if(!context.array_correct_dates[index]){
    context.array_correct_dates.push([]);
  }

  if(!context.array_correct_dates[index].includes(day)){
    context.array_correct_dates[index].push(day);
  }

  return 'z' + d;
}


// WEBPACK FOOTER //
// ./src/app/filters/getMonthDays.js